/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Name_LabelInputs */

const en_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset Name`)
};

const fr_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du prereglage`)
};

const de_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreingestellter Name`)
};

const it_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinito`)
};

const ru_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название предустановки`)
};

const es_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del preajuste`)
};

const zh_cn2_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设名称`)
};

const ja_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセット名`)
};

const hi_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट नाम`)
};

const pt_pt2_image_export_style_preset_name_label = /** @type {(inputs: Image_Export_Style_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinido`)
};

/**
* | output |
* | --- |
* | "Preset Name" |
*
* @param {Image_Export_Style_Preset_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_name_label = /** @type {((inputs?: Image_Export_Style_Preset_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_name_label(inputs)
	if (locale === "de") return de_image_export_style_preset_name_label(inputs)
	if (locale === "it") return it_image_export_style_preset_name_label(inputs)
	if (locale === "ru") return ru_image_export_style_preset_name_label(inputs)
	if (locale === "es") return es_image_export_style_preset_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_name_label(inputs)
	if (locale === "ja") return ja_image_export_style_preset_name_label(inputs)
	if (locale === "hi") return hi_image_export_style_preset_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_name_label(inputs)
	return en_image_export_style_preset_name_label(inputs)
});